const InvoicesFiles = () => import("./views/InvoicesFiles.vue");
const InvoiceFileEdit = () => import("./views/InvoiceFileEdit.vue");

const route = "/invoicesFiles";

export default [
  {
    path: route,
    name: "invoicesFiles.list",
    component: InvoicesFiles,

    meta: {
      roles: ["ROLE_ADMIN", "ROLE_INSTITUTIONS_ADMIN", "ROLE_PARENT", "ROLE_INSTITUTION_WORKER"],
    },
  },

  {
    path: `${route}/create`,
    name: "invoicesFiles.create",
    component: InvoiceFileEdit,

    meta: {
      roles: ["ROLE_ADMIN"],
    },
  },
];
